import React, { Component } from "react";
import { connect } from "react-redux";
import { List } from "antd";

import SubjectItem from "components/atar/SubjectItem";
import TableTopPopOver from "./pop-overs/TableTopPopOver";

class AdditionalSubjectsList extends Component {
  render() {
    const list = this.props.list;
    const { subjects } = this.props.input;
    const { userAddSubs } = this.props;
    return (
      <div>
        <TableTopPopOver />
        <List
          className="light-list"
          dataSource={list}
          renderItem={key => {
            const sub = subjects[key];
            return (
              <SubjectItem
                {...sub}
                prerequisite_of={null}
                handleToggleSubject={this.props.handleToggleSubject}
                subjectItemSelected={userAddSubs.includes(
                  sub.subject_num.toString()
                )}
                showSelect={true}
              />
            );
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = store => {
  const { input } = store.inputReducer;
  const { userAddSubs } = store.pickAddSubReducer;
  return {
    input: input,
    userAddSubs: userAddSubs
  };
};

export default connect(mapStateToProps)(AdditionalSubjectsList);
